export type StepsIconPalette = keyof typeof stepsIconNameMap;

export const stepsIconNameMap = {
  success: "custom-steps-success" as const,
  current: "custom-steps-current" as const,
  pending: "custom-steps-pending" as const,
} as const;

export function toStepsIconName(palette?: StepsIconPalette) {
  return `${stepsIconNameMap[palette ?? "pending"]}` as const;
}

export function toAriaCurrent(activeIndex: number, index: number) {
  return activeIndex === index ? "step" : undefined;
}

export function toEdge(total: number, index: number) {
  if (index === 0) return "start";
  if (index === total - 1) return "end";
  return "center";
}

export function toVariant(activeIndex: number, index: number) {
  if (activeIndex > index) return "success";
  if (activeIndex === index) return "current";
  return "pending";
}
